import { put, takeEvery, all, fork } from "redux-saga/effects";
import { CRUD_CREATE_SUCCESS, CRUD_UPDATE_SUCCESS, Record } from "react-admin";
import {
  CRUD_STATUS_CHANGE_SUCCESS,
  createCompanyCreatedAction,
  createCompanyUpdatedAction,
  createCrudStatusChangedAction,
  createCompanyDeactivatedAction,
} from "../../actions/appData";
import resourceNames from "../../../data/resourceNames";
import {
  CreateCompanyDto,
  RecordStatus,
  CompanyDto,
  UpdateCompanyDto,
} from "../../../data/service-proxies";
import { createDefaultHosDataSavedAction } from "../../actions/defaultHosData";

export function* companyCrudSaga() {
  yield all(
    [onCompanyCreateSaga, onCompanyEditSaga, onCompanyChangeStatusSaga].map(
      fork
    )
  );
}

function* onCompanyCreateSaga() {
  yield takeEvery(CRUD_CREATE_SUCCESS, handleCompanyCreate);
}

function* onCompanyEditSaga() {
  yield takeEvery(CRUD_UPDATE_SUCCESS, handleCompanyUpdate);
}

function* onCompanyChangeStatusSaga() {
  yield takeEvery(CRUD_STATUS_CHANGE_SUCCESS, handleCompanyChangedStatus);
}

function* handleCompanyCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_COMPANIES) {
    return;
  }

  const createRequest = action.requestPayload.data as CreateCompanyDto;
  const createdCompany = {
    ...createRequest,
    id: action.payload.data.id as number,
  };
  yield put(createCompanyCreatedAction(createdCompany));
}

function* handleCompanyUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_COMPANIES) {
    return;
  }

  if (!isCompany(action.payload.data)) {
    return;
  }

  if (action.payload.data.status !== RecordStatus.Active) {
    return;
  }

  const updateRequest = action.requestPayload.data as UpdateCompanyDto;
  const updatedCompany = {
    ...updateRequest,
  };
  yield put(createCompanyUpdatedAction(updatedCompany));
}

function* handleCompanyChangedStatus(
  action: ReturnType<typeof createCrudStatusChangedAction>
) {
  if (!isCompany(action.payload)) {
    return;
  }

  if (action.payload.status === RecordStatus.Active) {
    yield put(createCompanyCreatedAction(action.payload));
    yield put(
      createDefaultHosDataSavedAction({
        companyId: action.payload.id as number,
        timeZoneId: action.payload.homeTerminalTimeZone!,
        cycleRules: action.payload.cycleRules!,
        thirtyMinuteBreakException: action.payload.thirtyMinuteBreakException!,
        twentyFourHourCycleReset: action.payload.twentyFourHrCycleReset!,
        dvirWarnings: action.payload.dvirWarnings!,
        cargoType: action.payload.cargoType!,
        odometer: action.payload.odometer,
      })
    );
    return;
  }

  yield put(createCompanyDeactivatedAction(action.payload));
}

const isCompany = (payload: any): payload is CompanyDto => {
  return payload && "dot" in payload && "fleetOverSpeedingThreshold" in payload;
};
